import React from 'react';
import Typography from '@mui/material/Typography';
import PropTypes from 'prop-types';
import { getImage, GatsbyImage } from 'gatsby-plugin-image';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';

export const EditorJSBlock = ({ remoteTypeName, ...props }) => {
  if (remoteTypeName === 'EditorJSParagraphDataType') {
    return <Typography dangerouslySetInnerHTML={{ __html: props.text }} />;
  }
  if (remoteTypeName === 'EditorJSImageDataType') {
    return <GatsbyImage image={getImage(props.file.localImage)} alt={''} />;
  }
  if (remoteTypeName === 'EditorJSHeadingDataType') {
    return <Typography variant={`h${props.level}`}>{props.text}</Typography>;
  }
  if (remoteTypeName === 'EditorJSListDataType') {
    return (
      <List sx={{ listStyleType: 'disc',
        pl: 2,
        '& .MuiListItem-root': {
          display: 'list-item',
        } }}>
        {props.items.map((item, index) =>
          <ListItem key={index} sx={{ display: 'list-item' }}>{item}</ListItem>
        )}
      </List>
    );
  }
  console.log(`Error: ${remoteTypeName} not supported`);
  return null;

};
export default EditorJSBlock;

EditorJSBlock.propTypes = {
  remoteTypeName: PropTypes.oneOf(['EditorJSParagraphDataType'])
};